<template>
  <div>
    <h1>Posts</h1>
    <ul>
      <li v-for="post in posts" :key="post._id">
        <router-link :to="`/posts/${post._id}`">{{ post.title }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "PostsPage",
  data() {
    return {
      posts: [],
    };
  },
  async created() {
    try {
      const response = await axios.get("https://6footspeakeasy.com/api/data.php");
      this.posts = response.data;
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  },
};
</script>
